export function slugify(input) {
    return input
        .normalize('NFKD') // split accents
        .replace(/[\u0300-\u036f]/g, '') // drop accents
        .replace(/&/g, ' and ') // & → and
        .replace(/['’]/g, '') // drop apostrophes
        .replace(/[^a-zA-Z0-9]+/g, '-') // non-alphanum → -
        .replace(/^-+|-+$/g, '') // trim - at ends
        .replace(/-+/g, '-') // collapse ---
        .toLowerCase();
}
